import { AxiosResponse } from "axios";
import { LoginResponse } from "../../@types/DRO/LoginApiResponse";
import { authAxios, getAuthToken } from "../axiosInstances";

export class AuthenticationApi {
  public static api = new AuthenticationApi();
  private instance = authAxios;

  getToken() {
    return getAuthToken();
  }

  async onlineUserAuthentication(
    email: string,
    password: string
  ): Promise<LoginResponse> {
    try {
      const response: AxiosResponse<LoginResponse> = await this.instance.post(
        `/erp/user/login`,
        {
          email,
          password,
        }
      );
      if (response.data && [200, 2000].includes(response.data.code)) {
        localStorage.setItem("token", response.data.data.token);
      }
      return response.data;
    } catch (error) {
      throw new Error("Login failed");
    }
  }

  async authenticateWithSsoTicket(ticket: string): Promise<LoginResponse> {
    try {
      const response: AxiosResponse<LoginResponse> = await this.instance.post(
        `/erp/user/login`,
        undefined,
        {
          headers: {
            "X-SSO-Ticket": ticket,
          },
        }
      );
      if (response.data && [200, 2000].includes(response.data.code)) {
        localStorage.setItem("token", response.data.data.token);
      }
      return response.data;
    } catch (error) {
      throw new Error("SSO login failed");
    }
  }
}
